// services/statistic-data/hooks/useRevenueStatistic.ts

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RevenueStatisticResponseSchema } from "../response/RevenueStatisticResponse";

const API_VERSION = "v4";

// Interface untuk parameter filter (bisa menggunakan yang sama)
interface ParamsStatistic {
    property_id?: string;
    start_date?: string;
    end_date?: string;
}

// Interface untuk props yang diterima oleh hook
interface RevenueStatisticProps {
    filters: ParamsStatistic;
}

const useRevenueStatistic = (query: RevenueStatisticProps) => {
    return useQuery({
        // Kunci query yang unik
        queryKey: [
            'revenue-statistic',
            ...Object.entries(query.filters ?? {})
                .map(([key, value]) => `${key}:${value}`),
        ],
        queryFn: async () => {
            try {
                const params = {
                    filter: Object.fromEntries(
                        Object.entries(query.filters ?? {}).filter(([_key, value]) => value)
                    ),
                };

                const response = await privateApi.get(`/${API_VERSION}/channel-manager/statistics/revenue`, { params });

                const validationResult = RevenueStatisticResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Revenue Statistic data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Revenue Statistic`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useRevenueStatistic;